import { i18n } from '../plugins/i18n'

export const weekDays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

export function applyAveragesPerKm(fields, averages, currency, priceFormatter) {
  fields.list.forEach(field => {
    if (
      (field.group !== 'price_per_km' &&
        field.group !== 'return_price_per_km') ||
      field.attribute.endsWith('.price')
    ) {
      return
    }

    if (averages[field.group] && averages[field.group][field.initialValue]) {
      fields.byAttribute[
        field.attribute.replace('.km', '.price')
      ].helpText = i18n.t('company.average_price', {
        price: priceFormatter(convertPriceCurrency(averages[field.group][field.initialValue], currency)),
      })
    } else {
      fields.byAttribute[field.attribute.replace('.km', '.price')].helpText = ''
    }
  })
}

export function applyAverages(fields, averages, values, currency, priceFormatter) {
  fields.list.forEach(field => {
    if (
      (field.group === 'price_per_km' ||
        field.group === 'return_price_per_km') ||
      field.attribute === 'pricing.return_discount'
    ) {
      return
    }

    if (averages[field.attribute.replace('pricing.', '')]) {
      fields.byAttribute[field.attribute].helpText = i18n.t('company.average_price', {
        price: priceFormatter(convertPriceCurrency(averages[field.attribute.replace('pricing.', '')], currency)),
      })
    } else {
      fields.byAttribute[field.attribute].helpText = ''
    }
  })
}

export function convertPriceCurrency(price, currency) {
  let convertedPrice = null;
  if (price) {
    convertedPrice = (price * currency.rate).toFixed(2);
  }
  return convertedPrice
}
